import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class PseudonymAppointmentSuggestionCardAPI extends ComponentAPI {
    getConsultationLocation() {
        return this.state.consultationLocation;
    }
    setConsultationLocation(consultationLocation) {
        this.setState({ consultationLocation });
    }
    getConsultEndDate() {
        return this.state.consultEndDate;
    }
    setConsultEndDate(consultEndDate) {
        this.setState({ consultEndDate });
    }
    getConsultName() {
        return this.state.consultName;
    }
    setConsultName(consultName) {
        this.setState({ consultName });
    }
    getConsultStartDate() {
        return this.state.consultStartDate;
    }
    setConsultStartDate(consultStartDate) {
        this.setState({ consultStartDate });
    }
    getDirection() {
        return this.state.direction;
    }
    setDirection(direction) {
        this.setState({ direction });
    }
    getExamEndDate() {
        return this.state.examEndDate;
    }
    setExamEndDate(examEndDate) {
        this.setState({ examEndDate });
    }
    getExamName() {
        return this.state.examName;
    }
    setExamName(examName) {
        this.setState({ examName });
    }
    getExamStartDate() {
        return this.state.examStartDate;
    }
    setExamStartDate(examStartDate) {
        this.setState({ examStartDate });
    }
    getFilterParameter() {
        return this.state.filterParameter;
    }
    setFilterParameter(filterParameter) {
        this.setState({ filterParameter });
    }
    getSuggestions() {
        return this.state.suggestions;
    }
    setSuggestions(suggestions) {
        this.setState({ suggestions });
    }
}
export default PseudonymAppointmentSuggestionCardAPI;
//# sourceMappingURL=pseudonym-appointment-suggestion-card-api.js.map